import {initializeApp} from "firebase/app"

const API_KEY : string | undefined = process.env.REACT_APP_API_KEY;
const AUTH_DOMAIN : string  | undefined = process.env.REACT_APP_AUTH_DOMAIN;
const PROJECT_ID : string | undefined = process.env.REACT_APP_PROJECT_ID;
const STORAGE_BUCKET : string | undefined = process.env.REACT_APP_STORAGE_BUCKET;
const MESSAGING_SENDER_ID : string | undefined = process.env.REACT_APP_MESSAGING_SENDER_ID;
const APP_ID : string | undefined = process.env.REACT_APP_APP_ID;
const MEASUREMENT_ID : string | undefined = process.env.REACT_APP_MEASUREMENT_ID;
 export const VAPID_KEY : string | undefined = process.env.REACT_APP_VAPID_KEY;

const firebaseConfig = {
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    projectId: PROJECT_ID,
    storageBucket: STORAGE_BUCKET,
    messagingSenderId: MESSAGING_SENDER_ID,
    appId: APP_ID,
    measurementId: MEASUREMENT_ID
}

export const  firebase = initializeApp(firebaseConfig);